import React from 'react';
import './PolicyOligarchyDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {
  POLICY_OLIGARCHY_GUILD_INCOME_BONUS,
  POLICY_OLIGARCHY_GUILD_MAX_COUNT_IN_ONE_CITY,
} from "../../../../configs/policy/oligarchy";

const PolicyOligarchyDescription = () => {
  const hammerIcon = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/hammer brown.png'}
    alt={'Строительство'}
    title={'Строительство'}
  />;

  const cityIcon = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;

  const guild = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/guild.ee26d2b8.png'}
    alt={'Гильдия'}
    title={'Гильдия'}
  />;

  const guildIncome =
    <CoinsStat
      text={`+${POLICY_OLIGARCHY_GUILD_INCOME_BONUS}`}
      noShrinkOnMobile={true}
      isDarkColor={true}
    />;

  return (
    <>
      <div className={'policy-description_line'}>
        Можно {hammerIcon} до
        <span className={'text-construction policy-description-icon-margin-left'}>
          {POLICY_OLIGARCHY_GUILD_MAX_COUNT_IN_ONE_CITY}
        </span>
        {guild} в одном {cityIcon}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        Доход {guild} {guildIncome}.
      </div>
    </>
  );
};

export default PolicyOligarchyDescription;
